<template>
  <ul
    v-if="isPaginate"
    class="pagination"
  >
    <li class="pagination-item">
      <button
        :disabled="isInFirstPage"
        type="button"
        @click="onFirstPage"
      >
        <font-awesome-icon icon="angle-double-left" />
      </button>
    </li>

    <li class="pagination-item">
      <button
        :disabled="isInFirstPage"
        type="button"
        @click="onPreviousPage"
      >
        <font-awesome-icon icon="angle-left" />
      </button>
    </li>

    <li
      v-for="page in pages"
      :key="page.name"
      class="pagination-item"
    >
      <button
        :disabled="page.isDisabled"
        :class="{ active: isPageActive(page.name) }"
        type="button"
        @click="onPage(page.name)"
      >
        {{ page.name }}
      </button>
    </li>

    <li class="pagination-item">
      <button
        :disabled="isInLastPage"
        type="button"
        @click="onNextPage"
      >
        <font-awesome-icon icon="angle-right" />
      </button>
    </li>

    <li class="pagination-item">
      <button
        :disabled="isInLastPage"
        type="button"
        @click="onLastPage"
      >
        <font-awesome-icon icon="angle-double-right" />
      </button>
    </li>
  </ul>
</template>

<script>
import PaginationMixin from './PaginationMixin';

export default {
  name: 'pagination',

  mixins: [PaginationMixin],

  props: {
    maxVisibleButton: {
      type: Number,
      default: 3,
    },
  },

  computed: {
    startPage() {
      if (!this.isPaginate)
        return 0;

      if (this.pagination.currentPage === 1)
        return 1;

      if (this.pagination.currentPage === this.pagination.totalPage)
        return Math.max(this.pagination.totalPage - this.maxVisibleButton, 1);

      return this.pagination.currentPage - 1;      
    },

    pages() {
      const range = [];

      if (!this.isPaginate)
        return null;

      for (let i = this.startPage;
        i <= Math.min(this.startPage + this.maxVisibleButton + 1, this.pagination.totalPage);
        i ++ ) {
        range.push({
          name: i,
          isDisabled: i === this.pagination.currentPage,
        });
      }

      return range;
    },

    isInFirstPage() {
      return this.isPaginate && this.pagination.currentPage === 1;
    },

    isInLastPage() {
      return this.isPaginate && this.pagination.currentPage === this.pagination.totalPage;
    },
  },

  methods: {
    onFirstPage() {
      this.$emit('pagination:change-page', 1);
    },

    onPreviousPage() {
      this.$emit('pagination:change-page', this.pagination.currentPage - 1);
    },

    onPage(page) {
      this.$emit('pagination:change-page', page);
    },

    onNextPage() {
      this.$emit('pagination:change-page', this.pagination.currentPage + 1);
    },

    onLastPage() {
      this.$emit('pagination:change-page', this.pagination.totalPage);
    },

    isPageActive(page) {
      return this.pagination.currentPage === page;
    },
  },
}
</script>

<style scoped lang="scss">
.pagination {
  display:flex;
  list-style: none;
  border-radius: .25rem;
  margin:  auto 1rem !important;

  .pagination-item {
    display: inline-block;

    &:first-child button {
      border-top-left-radius: .25rem;
      border-bottom-left-radius: .25rem;
    }

    &:last-child button {
      border-top-right-radius: .25rem;
      border-bottom-right-radius: .25rem;
    }

    button {
      line-height: 1.25;
      padding: .4rem .66rem;
      color: #007bff;
      background-color: #fff;
      border: 1px solid #dee2e6;

      &.active {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
      }
    }
  }
}
</style>
